import { TranslationRepository } from '../data/translation-repository';
import { CopyLanguageValuesResult } from '../types/translation-types';

export class CopyLanguageValuesUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(
    newLanguageCode: string,
    baseLanguageCode: string
  ): Promise<CopyLanguageValuesResult> {
    return this.repository.copyLanguageValues(newLanguageCode, baseLanguageCode);
  }
}
